angular.module('charts')
    .directive('dblNoAssignmentsAlert', [function() {

    return {
        restrict: 'E',
        scope: {},
        templateUrl: '/resources/charts/directives/no-assignments-alert/dbl-no-assignments-alert.directive.html'
    };
}]);
